<template>
  <div class="mv-scrub" :class="{ 'is-disabled': disabled }" @mousedown.prevent="startDrag">
    <div class="mv-scrub-track">
      <div v-if="hasRange" class="mv-scrub-range" :style="{ left: pct(rangeStart), width: pct(rangeEnd - rangeStart) }"></div>
      <div class="mv-scrub-played" :style="{ width: pct(time) }"></div>
    </div>
    <div v-if="rangeIn != null" class="mv-scrub-tick" :style="{ left: pct(rangeIn) }"></div>
    <div v-if="rangeOut != null" class="mv-scrub-tick" :style="{ left: pct(rangeOut) }"></div>
    <div class="mv-scrub-head" :style="{ left: pct(time) }"></div>
  </div>
</template>

<script>
// Click to jump, drag to scrub; everything is in seconds and drawn in % of the duration.
export default {
  props: {
    duration: { type: Number, default: 0 },
    time: { type: Number, default: 0 },
    rangeIn: { type: Number, default: null },
    rangeOut: { type: Number, default: null },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    hasRange() {
      return this.rangeIn != null || this.rangeOut != null;
    },
    rangeStart() {
      return this.rangeIn ?? 0;
    },
    rangeEnd() {
      return this.rangeOut ?? this.duration;
    },
  },
  methods: {
    pct(secs) {
      return this.duration > 0 ? Math.min(100, Math.max(0, (secs / this.duration) * 100)) + "%" : "0%";
    },
    // The rect is read once per drag; window listeners keep the drag alive outside the bar.
    startDrag(event) {
      if (this.disabled || !(this.duration > 0)) return;
      const rect = this.$el.getBoundingClientRect();
      const seekTo = (clientX) => {
        const fraction = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
        this.$emit("seek", fraction * this.duration);
      };
      seekTo(event.clientX);
      const move = (moveEvent) => seekTo(moveEvent.clientX);
      this.stopDrag = () => {
        window.removeEventListener("mousemove", move);
        window.removeEventListener("mouseup", this.stopDrag);
        this.stopDrag = null;
      };
      window.addEventListener("mousemove", move);
      window.addEventListener("mouseup", this.stopDrag);
    },
  },
  beforeDestroy() {
    if (this.stopDrag) this.stopDrag();
  },
};
</script>

